'use es6';

import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { getEventValue } from '../../../utils/jsEventUtils';
import { useDomains } from '../../../data/hooks/useDomains';
import PortalIdParser from 'PortalIdParser';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { Link as FoundationsLink, Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const externalRecipientsPropDefault = new Set();
const EmailExternalRecipientSelect = ({
  onChange,
  externalRecipients = externalRecipientsPropDefault,
  onValidationError,
  validationErrorState,
  appUsageTracker
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const {
    data: externalDomains
  } = useDomains();
  // come back to performance possibly

  const [recipientObjects, setRecipientObjects] = useState([]);

  // may need to return to this to validate the prefix of the email
  const validateEmail = input => {
    const splitEmail = input.split('@');
    return splitEmail.length === 2 && splitEmail[0] !== '' && externalDomains.includes(splitEmail[1]);
  };
  let validationError = false;
  const createRecipientObjects = set => {
    validationError = false;
    const selections = [];
    set.forEach(email => {
      const valid = validateEmail(email);
      if (!valid) {
        validationError = true;
      }
      selections.push({
        text: email,
        value: email,
        tagUse: valid ? '' : 'candy-apple'
      });
    });
    onValidationError(validationError);
    return selections;
  };
  const getFieldValues = event => {
    const recipients = new Set(recipientObjects.map(recipient => recipient.value));
    recipients.add(event.target.value);
    return recipients;
  };
  const handleChange = event => {
    if (event.target.value === '') return;
    const newSelection = event.type === 'blur' ? getFieldValues(event) : new Set(getEventValue(event));
    setRecipientObjects(createRecipientObjects(newSelection));
    onChange(newSelection);
  };
  const settingsUrl = `/settings/${PortalIdParser.get()}/domains/business-unit/view-all/`;
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.selectLabel"
    }),
    tooltip: externalDomains.length === 0 ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.knowledgebaseTooltip_jsx",
      elements: {
        Link: props => {
          return /*#__PURE__*/_jsx(Link, {
            external: true,
            href: "https://knowledge.hubspot.com/dashboard/email-or-export-reports-and-dashboards",
            onClick: () => {
              usageTracker.track(EVENTS.clickAccountSettingExternalEmailToolTipLink, {
                actionType: 'click',
                action: 'Navigate-to-learn-more-about-connecting-verified-domains',
                assetType: 'dashboard'
              });
            },
            children: props.children
          });
        }
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.settingsTooltip_jsx",
      elements: {
        Link: props => {
          return /*#__PURE__*/_jsx(FoundationsLink, {
            external: true,
            href: settingsUrl,
            onClick: () => {
              usageTracker.track(EVENTS.clickAccountSettingExternalEmailToolTipLink, {
                actionType: 'click',
                action: 'Navigate-to-account-settings-page',
                assetType: 'dashboard'
              });
            },
            children: props.children
          });
        }
      }
    }),
    tooltipPlacement: 'right',
    error: validationErrorState,
    validationMessage: validationErrorState && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.errorMessage_jsx",
      options: {
        settingsUrl
      },
      elements: {
        Link: FoundationsLink
      }
    }),
    children: /*#__PURE__*/_jsx(Select, {
      anchorType: "combined",
      allowCreate: true,
      open: false,
      onChange: handleChange,
      options: recipientObjects,
      value: Array.from(externalRecipients),
      multi: true,
      placeholder: " ",
      splitRegex: /,|;|\s/
    })
  });
};
EmailExternalRecipientSelect.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  externalRecipients: PropTypes.instanceOf(Set).isRequired,
  onValidationError: PropTypes.func.isRequired,
  validationErrorState: PropTypes.bool.isRequired
};
export default EmailExternalRecipientSelect;